import { render, staticRenderFns } from "./QuestionsAndAnswers.vue?vue&type=template&id=f3d9a156"
import script from "./QuestionsAndAnswers.vue?vue&type=script&lang=js"
export * from "./QuestionsAndAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports